import { Directive, Input, OnChanges } from '@angular/core';
import { StandardPinService } from '../../../services/standard-pin.service';
import { StandardAssignmentPins } from './standard-assignment-pins';

const EMPTY_ID = '';

@Directive({
  selector: '[standardAssignmentPins]',
  exportAs: 'assignmentPins',
  providers: [StandardAssignmentPins, StandardPinService]
})
export class StandardAssignmentPinsDirective implements OnChanges {
  @Input() pinStandardId = EMPTY_ID;
  @Input() pinsVisible = false;

  constructor(public pins: StandardAssignmentPins) {}

  ngOnChanges(): void { this.pins.open(this.pinStandardId, this.pinsVisible); }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standard-assignment-pins.directive.ts